import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, FileText, Shield, Cookie, ScrollText, Users, Mail } from 'lucide-react';

export const Footer = ({ onOpenCookieSettings }) => {
    const currentYear = new Date().getFullYear();

    const policyLinks = [
        { label: 'Impressum', path: '/impressum', icon: FileText },
        { label: 'Datenschutz', path: '/datenschutz', icon: Shield },
        { label: 'AGB', path: '/agb', icon: ScrollText },
    ];

    const infoLinks = [
        { label: 'Über uns', path: '/ueber-uns', icon: Users },
        { label: 'Kontakt', path: '/kontakt', icon: Mail },
    ];

    return (
        <footer className="bg-footer-bg text-footer-text">
            <div className="section-container py-12 md:py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
                    {/* Brand Column */}
                    <div className="md:col-span-1">
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 text-footer-text font-bold text-lg mb-4"
                        >
                            <Leaf className="h-5 w-5" />
                            <span>DetoxTeeTest</span>
                        </Link>
                        <p className="text-sm text-footer-text/70 leading-relaxed">
                            Ihr unabhängiges Verbraucherportal für Detox Tee Vergleiche.
                            Wir testen und vergleichen Produkte nach objektiven Kriterien.
                        </p>
                    </div>

                    {/* Legal Links */}
                    <div className="md:col-span-1">
                        <h3 className="font-semibold text-footer-text mb-4">
                            Rechtliches
                        </h3>
                        <ul className="space-y-3">
                            {policyLinks.map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="footer-link inline-flex items-center gap-2"
                                    >
                                        <link.icon className="h-4 w-4" />
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <button
                                    onClick={onOpenCookieSettings}
                                    className="footer-link inline-flex items-center gap-2 bg-transparent border-none cursor-pointer p-0"
                                >
                                    <Cookie className="h-4 w-4" />
                                    Cookie Einstellungen
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Info Links */}
                    <div className="md:col-span-1">
                        <h3 className="font-semibold text-footer-text mb-4">
                            Information
                        </h3>
                        <ul className="space-y-3">
                            {infoLinks.map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="footer-link inline-flex items-center gap-2"
                                    >
                                        <link.icon className="h-4 w-4" />
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Quick Links */}
                    <div className="md:col-span-1">
                        <h3 className="font-semibold text-footer-text mb-4">
                            Schnellzugriff
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <a
                                    href="#testsieger"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        document
                                            .querySelector('#vergleich')
                                            ?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                    className="footer-link"
                                >
                                    Testsieger 2026
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#vergleich"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        document
                                            .querySelector('#vergleich')
                                            ?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                    className="footer-link"
                                >
                                    Produktvergleich
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#faq"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        document
                                            .querySelector('#faq')
                                            ?.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                    className="footer-link"
                                >
                                    Häufige Fragen
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-footer-text/10 mt-10 pt-8">
                    {/* Affiliate Disclosure */}
                    <div className="bg-footer-text/5 rounded-lg p-4 mb-6">
                        <p className="text-xs text-footer-text/70 text-center leading-relaxed">
                            <strong className="text-footer-text/90">Hinweis:</strong>{' '}
                            Wir sind ein unabhängiges Verbraucherportal. Einige Links
                            können Affiliate-Links sein. Bei einem Kauf über diese Links
                            erhalten wir möglicherweise eine Provision – für Sie entstehen
                            dabei keine zusätzlichen Kosten.
                        </p>
                    </div>

                    {/* Bottom Row */}
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <p className="text-xs text-footer-text/50">
                            © {currentYear} DetoxTeeTest.com – Alle Rechte vorbehalten
                        </p>
                        <p className="text-xs text-footer-text/50">
                            Stand: Januar 2026
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};
